import { BaseAPI } from '../base.api'
import { VUE_APP_SIT_PEDIDOS_API_URL } from '@/commons/config'
import { AxiosObservable } from 'axios-observable'

export class VeiculoAPI extends BaseAPI<any> {
  constructor() {
   super()
   this.apiUrl = `${VUE_APP_SIT_PEDIDOS_API_URL}/api`
  }

  public getTipoServicoTransportadora(transportadoraId: number): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/veiculo/tipos-servicos?transportadoraId=${transportadoraId}`)
  }

  public getTipoVeiculo(): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/veiculo/tipo-veiculo`)
  }

  public getAreasAtuacaoTransportadora(transportadoraId: number): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/veiculo/areas-atuacao?transportadoraId=${transportadoraId}`)
  }

  public getCooperadosTransportadora(transportadoraId: number): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/veiculo/cooperados-transportadora?transportadoraId=${transportadoraId}`)
  }

  public getDadosVeiculo(placa: string): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/veiculo/dados-veiculo?placa=${placa}`)
  }

  public getRegioesMetropolitanas(): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/veiculo/regiao-metropolitana`)
  }
}
